import userApi from '@/api/user'
import * as types from '../mutation-types'

// the definition of initial state is required.
const state = {
  id: -1,
  username: '',
}

const getters = {
  isLoggedIn: state => state.id !== -1
}

const actions = {
  getMe({ commit, state, getters }, { forceRefresh } = {}) {
    if (!forceRefresh && getters.isLoggedIn) {
      return Promise.resolve(Object.assign({}, state))
    }
    return userApi.getMe()
      .then(({ data }) => {
        commit(types.SET_LOGIN_USER, { data })
        return Object.assign({}, state)
      })
  },
  login({ commit, state }, data) {
    return userApi.login(data)
      .then(({ data }) => {
        commit(types.SET_LOGIN_USER, { data })
        return Object.assign({}, state)
      })
  },
  logout({ commit }) {
    return userApi.logout()
      .then(() => {
        commit(types.CLEAR_LOGIN_USER)
      })
  }
}

const mutations = {
  [types.SET_LOGIN_USER](state, { data }) {
    Object.keys(data).forEach(k => {
      state[k] = data[k]
    })
  },
  [types.CLEAR_LOGIN_USER](state) {
    state.id = -1
    state.username = ''
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
